/**
 * Local / preview suggest data when Funnelback is unavailable or for UI work.
 * Enable: npm start (development default), ?searchMock=1, or localStorage bv-search-suggest-mock=1
 * Disable: ?searchMock=0 or localStorage bv-search-suggest-mock=0
 */

import { SEARCH_SUGGEST_MAX_RESULTS } from "./searchOverlayConstants";

export const MOCK_SUGGESTION_PHRASES = [
  "Starting a business",
  "Business grants and funding",
  "Register your business name",
  "Business plan template",
  "Employing staff in Victoria",
  "Export from Victoria",
  "Business licences and permits",
  "Small business support",
  "Grants for small business",
  "Find a business mentor",
  "Business Victoria events",
  "Cyber security for business"
];

const MOCK_DELAY_MS = 200;

export function shouldUseSearchSuggestMock() {
  if (typeof window === "undefined") {
    return process.env.NODE_ENV === "development";
  }

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("searchMock") === "0") {
      return false;
    }
    if (params.get("searchMock") === "1") {
      return true;
    }
    const stored = window.localStorage.getItem("bv-search-suggest-mock");
    if (stored === "0") {
      return false;
    }
    if (stored === "1") {
      return true;
    }
  } catch (e) {
    // localStorage / URL may be blocked
  }

  return process.env.NODE_ENV === "development";
}

/** Same shape as Funnelback suggest items ({ disp }). */
export function filterMockSuggestions(
  partialQuery,
  limit = SEARCH_SUGGEST_MAX_RESULTS
) {
  const query = partialQuery.trim().toLowerCase();
  if (!query) {
    return [];
  }

  return MOCK_SUGGESTION_PHRASES.filter(phrase =>
    phrase.toLowerCase().includes(query)
  )
    .slice(0, limit)
    .map(disp => ({ disp }));
}

export function fetchMockSuggestions(
  term,
  { signal, delayMs = MOCK_DELAY_MS } = {}
) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException("Aborted", "AbortError"));
      return;
    }

    const onAbort = () => {
      clearTimeout(timer);
      reject(new DOMException("Aborted", "AbortError"));
    };

    const timer = setTimeout(() => {
      signal?.removeEventListener("abort", onAbort);
      if (signal?.aborted) {
        reject(new DOMException("Aborted", "AbortError"));
        return;
      }
      resolve(filterMockSuggestions(term));
    }, delayMs);

    signal?.addEventListener("abort", onAbort);
  });
}
